import { useCallback, useMemo, useState } from "react";

export default function useObjectInput<T extends object>(defaultValue: T) {
  const [inputs, setInputs] = useState<T>(defaultValue);

  const onChange = useCallback(
    (event: any) => {
      const { value, name } = event.target;

      setInputs({ ...inputs, [name]: value });
    },
    [inputs]
  );

  const onReset = useCallback(() => {
    setInputs(defaultValue);
  }, [defaultValue]);

  return useMemo(() => ({ inputs, onChange, setInputs, onReset }), [inputs]);
}
